/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
export class GlobalConfiguration {
    // eslint-disable-next-line @tylertech-eslint/require-private-modifier
    constructor() { }
    /**
     * Gets an entry from the global configuration for the specified element.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    static get(element) {
        const entry = window.TylerForgeGlobalConfiguration?.[element];
        if (!entry) {
            return null;
        }
        return {
            has(key) {
                return key in entry;
            },
            valueOf(key) {
                return entry[key];
            }
        };
    }
}
